
import {
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';
export interface CptlimitModel{
  id: number;
  insurance_id: number;
  location_id: number;
  cpt_code: string;
  max_per_day: number;
  location?: {
    id: number;
    title: string;
  };
}

export class CptLimit{
  id: number = 0;
  insurance_id: number = 0;
  location_id: number = 0;
  cpt_code: string = '';
  max_per_day: number = 0;
  location?: {
    id: number;
    title: string;
  };

  constructor(data: Partial<CptlimitModel>) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.insurance_id = NumberOrNullOrUndefined(data.insurance_id) ?? 0;
    this.location_id = NumberOrNullOrUndefined(data.location_id) ?? 0;
    this.cpt_code = StringOrNullOrUndefined(data.cpt_code) ?? '';
    this.max_per_day = NumberOrNullOrUndefined(data.max_per_day) ?? 0;
    this.location = data?.location;
  }


}
